import Api from './Api';

export default class ParceirosApi {

  all = async () => {
    return await Api.get(`/parceiros`).then(response => response.data)
      .catch((error) => console.log('[PARCEIROS][ALL] Error\n', error));
  }

  parcerias = async () => {
    return await Api.get(`/parceiros/parcerias`).then(response => response.data)
      .catch((error) => console.log('[PARCEIROS][PARCERIAS] Error\n', error));
  }

  pesquisar = async (pesquisa) => {
    return await Api.get(`/parceiros/pesquisar/${pesquisa}`).then(response => response.data)
      .catch((error) => console.log('[PARCEIROS][PESQUISAR] Error\n', error));
  }

}